//@ts-nocheck
"use client";

import { useEffect } from "react";

const ClarityHeadTag = () => {
    useEffect(() => {
        // Create Clarity script element
        const script = document.createElement("script");

        script.innerHTML = `
            (function(c,l,a,r,i,t,y){
                c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                t=l.createElement(r);
                t.async=1;
                t.src="https://www.clarity.ms/tag/"+i;
                y=l.getElementsByTagName(r)[0];
                y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "xv6wh40uj8");
        `;

        document.head.prepend(script);

        return () => {
            document.head.removeChild(script);
        };
    }, []);

    return null;
};

export default ClarityHeadTag;